/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: '/dashboard',
    icon: 'ActivityIcon',
    i18n: 'Dashboard'
  },
  {
    url: '/gas',
    icon: 'CpuIcon',
    i18n: 'Devices'
  },
  {
    url: '/map',
    icon: 'MapIcon',
    i18n: 'Map'
  }
]
